import url from "url";

export type PartialSchemaReference = {
  name: string;
  namespace?: string;
};

export const schemaPath = ({ name, namespace }: PartialSchemaReference) =>
  `/@${namespace || "schema"}/schemas/${name}`;

export function resolveUrl(u: string): url.Url {
  return url.parse(url.resolve("http://schema.org", u));
}

export function getSchemaNameFromUrl(u: url.Url | string): string | null {
  const parsed = typeof u === "string" ? resolveUrl(u) : u;

  if (
    parsed.host === "schema.org" &&
    parsed.pathname?.lastIndexOf("/") === 0 &&
    !parsed.search
  ) {
    return parsed.pathname.slice(1);
  }

  return null;
}

export function transformUrl(schemaDescriptionUrl: string): string {
  const parsed = resolveUrl(schemaDescriptionUrl);
  const name = getSchemaNameFromUrl(parsed);

  if (name) {
    return schemaPath({ name, namespace: "schema" });
  }

  return url.format(parsed);
}
